<section class="slds-fade-in-open slds-modal_large slds-list-builder" tabindex="-1">
  <div class="slds-modal__container modal-box-shadow">
    <ng-content></ng-content>
  </div>
</section>
